<template>
  <el-dialog
    v-model="isVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    class="order-test build-bundle-start-dialog"
    append-to-body
    title="Choose a Bundle to Get Started"
    width="970px"
    @close="handleClose"
  >
    <div class="build-bundle-start">
      <div class="header-text">
        <p class="subtitle">
          Select a bundle option to begin building your custom package. Each bundle allows you to mix and match Zoomers and Panels based on your needs.
        </p>
      </div>

      <div class="bundle-card-row">
        <BundleCard
          v-for="bundle in bundles"
          :key="bundle.bundleId"
          :price-label="`${currency.symbol}${bundle.price} Bundle`"
          :description="bundle.bundleName"
          :selected="selectedBundle && selectedBundle.bundleId === bundle.bundleId"
          :disabled="disabledBundleIds.includes(bundle.bundleId)"
          @toggle="toggleSelect(bundle)"
        />
      </div>
    </div>
  </el-dialog>
  <BuildBundleDialog
    v-if="isBuildBundleDialogOpen"
    :is-show-dialog="isBuildBundleDialogOpen"
    :bundle-id="currentBundle.bundleId"
    @close="isBuildBundleDialogOpen = false"
    @cancel="handleBuildBundleDialogCancel"
    @add-to-cart="addBuildBundlePromo"
  />
</template>

<script>
import BundleCard from "./BundleCard.vue";
import BuildBundleDialog from "../build-bundle-dialog/index.vue";
import { mapGetters, mapState } from 'vuex';

export default {
  name: "BuildBundleStart",
  components: {
    BundleCard,
    BuildBundleDialog,
  },
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
    bundles: {
      type: Array,
      default: () => [],
    },
    disabledBundleIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["close", "continue", "add-to-cart"],
  data() {
    return {
      isVisible: false,
      selectedBundle: null,
      isBuildBundleDialogOpen: false,
      currentBundle: null,
    };
  },
  computed: {
    ...mapState(["currency"]),
    ...mapGetters("orderTest/tests", ["testList"]),
  },
  watch: {
    isShowDialog: {
      immediate: true,
      handler(val) {
        this.isVisible = val;
        if (val) {
          this.selectedBundle = null;
        }
      },
    },
  },
  methods: {
    handleClose() {
      this.isVisible = false;
      this.$emit("close");
    },
    toggleSelect(bundle) {
      if (this.disabledBundleIds.includes(bundle.bundleId)) {
        return;
      }
      this.selectedBundle = (this.selectedBundle && this.selectedBundle.bundleId === bundle.bundleId)
        ? null
        : bundle;
      if (this.selectedBundle) {
        this.handleContinue();
      }
    },
    handleContinue() {
      if (!this.selectedBundle) return;
      this.currentBundle = this.selectedBundle;
      this.isBuildBundleDialogOpen = true;
      this.handleClose();
    },
    handleBuildBundleDialogCancel() {
      // User clicked Cancel button - close BuildBundleDialog and reopen Choose a Bundle dialog
      this.isBuildBundleDialogOpen = false;
      this.selectedBundle = null;
      this.currentBundle = null;
      this.isVisible = true;
    },
    addBuildBundlePromo(payload) {
      this.isBuildBundleDialogOpen = false;
      this.$emit("add-to-cart", payload);
    },
  }
};
</script>

<style scoped>
.build-bundle-start {
  display: flex;
  flex-direction: column;
  padding: 24px;
}

.header-text {
  padding: 0 40px;
  margin-bottom: 12px;
  box-sizing: border-box;
}

.header-text .subtitle {
  color: var(--TrueBlack, #333);
  /* EHR_BodyM_14_Web */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.25px;
  margin-top: 16px;
  margin-bottom: 16px;
}

.bundle-card-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  padding: 0 40px;
  margin-top: 12px;
  margin-bottom: 32px;
  margin-left: 24px;
  margin-right: 24px;
  box-sizing: border-box;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  padding: 0 40px;
  box-sizing: border-box;
}

.bundle-footer-btn {
  min-width: 140px;
}

</style>

<style>
.el-dialog.build-bundle-start-dialog {
  --el-dialog-padding-primary: 0px;
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
}

.el-dialog.build-bundle-start-dialog .el-dialog__header {
  margin: 0;
  padding: 12px 24px;
  min-height: 60px;
  display: flex;
  align-items: center;
  background: #004879;
  border-bottom: none;
}

.el-dialog.build-bundle-start-dialog .el-dialog__body {
  padding: 0;
}

.el-dialog.build-bundle-start-dialog .el-dialog__title {
  color: #FFF;
  font-family: Inter, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.el-dialog.build-bundle-start-dialog .el-dialog__headerbtn {
  top: 10px;
  right: 20px;
  width: 28px;
  height: 28px;
  margin: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.el-dialog.build-bundle-start-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #ffffff;
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
  opacity: 1;
}

.el-dialog.build-bundle-start-dialog .el-dialog__headerbtn .el-icon,
.el-dialog.build-bundle-start-dialog .el-dialog__headerbtn svg {
  color: #ffffff;
  fill: #ffffff;
  width: 24px;
  height: 24px;
}
</style>
